module.exports = __webpack_public_path__ + "img/img_client_androidTv.abbd461d.jpg";